const form = {
  url: "https://docs.google.com/forms/u/3/d/e/1FAIpQLScqaKnTL3o_vUpnQF1G_FM-u-0YCg93XPu56TKEAG3aH7QNEg/formResponse",
  method: "post",
};

export default form;
